import { render, staticRenderFns } from "./offer-packages.vue?vue&type=template&id=35711897"
import script from "./offer-packages.vue?vue&type=script&lang=js"
export * from "./offer-packages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports